var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoAddSiret(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 8C0 3.58172 3.58172 0 8 0H16C20.4183 0 24 3.58172 24 8V16C24 20.4183 20.4183 24 16 24H8C3.58172 24 0 20.4183 0 16V8Z",
    fill: "#62AA47"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1740_5865)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.2542 6.00266C14.3802 6.01504 14.4986 6.07027 14.5889 6.1598L17.3389 8.88707C17.442 8.98937 17.5 9.12806 17.5 9.27273V16.3636C17.5 16.7976 17.326 17.2137 17.0166 17.5206C16.7072 17.8275 16.2876 18 15.85 18H8.15C7.84624 18 7.6 17.7558 7.6 17.4545C7.6 17.1533 7.84624 16.9091 8.15 16.9091H15.85C15.9959 16.9091 16.1357 16.8516 16.2389 16.7493C16.342 16.647 16.4 16.5083 16.4 16.3636V10.3636H14.75C14.3124 10.3636 13.8928 10.1911 13.5834 9.88423C13.274 9.57736 13.1 9.16126 13.1 8.72727V7.09091H9.25C9.10413 7.09091 8.96428 7.14842 8.86113 7.25071C8.75799 7.353 8.7 7.4917 8.7 7.63636V9.81818C8.7 10.1194 8.45376 10.3636 8.15 10.3636C7.84624 10.3636 7.6 10.1194 7.6 9.81818V7.63636C7.6 7.20237 7.77396 6.78628 8.0834 6.4794C8.39283 6.17253 8.81239 6 9.25 6H14.2L14.2542 6.00266ZM14.2 8.72727C14.2 8.87194 14.258 9.01063 14.3611 9.11293C14.4643 9.21522 14.6041 9.27273 14.75 9.27273H16.1723L14.2 7.31676V8.72727Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.15 11.4545C9.06127 11.4545 9.8 12.1872 9.8 13.0909V14.1818C9.8 15.0856 9.06127 15.8182 8.15 15.8182C7.23873 15.8182 6.5 15.0856 6.5 14.1818V13.0909C6.5 12.1872 7.23873 11.4545 8.15 11.4545ZM8.15 12.5455C7.84624 12.5455 7.6 12.7897 7.6 13.0909V14.1818C7.6 14.4831 7.84624 14.7273 8.15 14.7273C8.45376 14.7273 8.7 14.4831 8.7 14.1818V13.0909C8.7 12.7897 8.45376 12.5455 8.15 12.5455Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6064 11.4572C12.8837 11.4852 13.1 11.7176 13.1 12V14.7273H13.65C13.9538 14.7273 14.2 14.9715 14.2 15.2727C14.2 15.574 13.9538 15.8182 13.65 15.8182H11.45C11.1462 15.8182 10.9 15.574 10.9 15.2727C10.9 14.9715 11.1462 14.7273 11.45 14.7273H12V12.5455H11.45C11.1462 12.5455 10.9 12.3012 10.9 12C10.9 11.6988 11.1462 11.4545 11.45 11.4545H12.55L12.6064 11.4572Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1740_5865"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "translate(6 6)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoAddSiret);
export default __webpack_public_path__ + "static/media/logoAddSiret.7dc1f84e562eaab39aa9f9d255479d88.svg";
export { ForwardRef as ReactComponent };